import axios from 'axios';
import endpoints from '@/api/endpoints';
import store from '@/store';
import router from '@/router';
import moment from 'moment';

export default {
  checkSession () {
    let lastActivity = store.getters.getSessionStart
    let duration = moment.duration(moment().diff(lastActivity))
    let minutes = duration.asMinutes()

    // minutes here are the number of minutes before user should be auto-logged out
    if (store.getters.isSessionActive) {
      if (minutes > store.getters.getSessionLength) {
        this.timeoutLogout()
        return false
      } else {
        // store.dispatch('startSessionTimer')
        // store.dispatch('resetApiErrors')
        return true
      }
    }
    return false
  },
  async getUserProfile () {
    return await axios.get(endpoints.userData).then((response) => {
      return response.data[0].profile
    })
  },
  async getUserID () {
    return await axios.get(endpoints.userData).then((response) => {
      return response.data[0].userid
    })
  },
  async getUser (userID) {
    return await axios.get(endpoints.users + userID + '/').then((response) => {
      return response.data
    })
  },
  async getUserApps () {
    return await axios.get(endpoints.appAccess + '?user=' + store.state.auth.userid).then((response) => {
      return response.data
    })
  },
  async forgotPassword(obj) {
    return axios.post(endpoints.forgotPassword, obj).then((response) => {
      return response.data
    })
  },
  async logoutHelper () {
    if (store.getters.isSessionActive) {
      store.dispatch('endSession')
      await axios.get(endpoints.logout)
    }
    axios.defaults.headers.common = null
    localStorage.removeItem('token')
    localStorage.removeItem('userid')
    store.dispatch('resetStore')
  },
  async logout () {
    this.logoutHelper()
  },
  async timeoutLogout () {
    this.logoutHelper()
    router.push({ name: 'Logout', params: { auto: true } })
    await this.logoutFinisher()
  }
}
